import loadable from '@loadable/component';
export const manifest = {
  SmeSharik: {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeSharik";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeSharik" */
          './sme-sharik'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./sme-sharik");
            }

            return eval('require.resolve')("./sme-sharik");
          }

        }, {
          resolveComponent: m => m.SmeSharik
        })
      }
    }
  },
  'SmeSharik.Control': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeSharikControl";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeSharikControl" */
          './sme-sharik-control'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./sme-sharik-control");
            }

            return eval('require.resolve')("./sme-sharik-control");
          }

        }, {
          resolveComponent: m => m.SmeSharikControl
        })
      }
    }
  },
  'SmeSharik.Button': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeSharikButton";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeSharikButton" */
          './sme-sharik-button'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./sme-sharik-button");
            }

            return eval('require.resolve')("./sme-sharik-button");
          }

        }, {
          resolveComponent: m => m.SmeSharikButtonDesktop
        })
      }
    }
  },
  'SmeSharik.Cards': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeSharikCards";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeSharikCards" */
          './sme-sharik-cards'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./sme-sharik-cards");
            }

            return eval('require.resolve')("./sme-sharik-cards");
          }

        }, {
          resolveComponent: m => m.SmeSharikCards
        })
      }
    }
  }
};